<template lang="html">
  <div
    :class="['banner', size]"
    :style="{ 'background-image': 'url(' + imageCoverURL + ')' }"
  >
    <div class="cortina"></div>

    <Navbar />
    <div class="nav-false" id="prueba"></div>
    <div class="container">
      <div class="content py-5">
        <h2 class="title" data-aos="fade-right" data-aos-duration="1000">
          {{ title }}
        </h2>
        <h4
          v-if="subtitle"
          class="subtitle"
          data-aos="fade-right"
          data-aos-duration="1300"
        >
          {{ subtitle }}
        </h4>
        <h4
          v-if="breadcrumb"
          class="breadcrumb"
          data-aos="fade-right"
          data-aos-duration="1500"
        >
          {{ breadcrumb }}
        </h4>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./Navbar.vue";
export default {
  props: {
    size: {
      type: String,
      default: "large",
    },
    imageCoverURL: String,
    title: String,
    subtitle: String,
    breadcrumb: String,
  },
  components: {
    Navbar,
  },

  created() {
    window.addEventListener("scroll", this.isScrollNavFalse);
    let htmlPage = document.querySelector("html");
    htmlPage.style.overflowY = "auto";
    window.scrollTo(0, 0);
  },
  unmounted() {
    window.removeEventListener("scroll", this.isScrollNavFalse);
  },
  methods: {
    isScrollNavFalse() {
      let navFalse = document.getElementById("prueba");
      let windowPositionY = window.pageYOffset;
      if (windowPositionY > 100) {
        navFalse.classList.add("nav-true");
      } else if (windowPositionY == 0) {
        navFalse.classList.remove("nav-true");
      }
    },
  },
};
</script>
<style lang="css" scoped>
.banner {
  width: 100%;
  position: relative;
  background-size: cover;
  z-index: auto;
}
.cortina {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}
.banner.small {
  height: 390px;
}
.banner.large {
  height: 580px;
}
.banner .container {
  position: relative;
  z-index: 2;
}
.banner .content {
  height: calc(580px - 160px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.banner.small .content {
  height: calc(390px - 160px);
}
.banner .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 59px;
  color: #ffffff;
  max-width: 640px;
  margin-bottom: 10px;
  position: unset;
}
.banner.small .content .title {
  font-weight: 300;
  font-size: 40px;
  line-height: 47px;
}
.banner .content .subtitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.275em;
  text-transform: uppercase;
  color: #ffffff;
}
.banner .content .breadcrumb {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 0;
}

@media (max-width: 992px) {
  .banner.large {
    height: 420px;
  }
  .banner .content {
    height: calc(390px - 160px);
  }
  .banner.large .content .title {
    font-size: 32px;
    line-height: 38px;
  }
}
.nav-false {
  height: 185px;
  display: none;
}
.nav-true {
  height: 185px;
  display: block;
}
.banner.medium {
  height: 390px;
}
.banner.medium .content {
  height: calc(390px - 160px);
}
.banner.medium .content .title {
  font-weight: 700 !important;
}
@media (max-width: 768px) {
  .nav-true {
    height: 130px;
  }
}
</style>
